import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
  selector: 'l-layout',
  templateUrl: './layout.component.html',
  imports: [
    NgClass
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LayoutComponent {

  @Input()
  public fullscreen: boolean = false;

}
